// extracted by css-extract-rspack-plugin
export default {"tip":"KKERqUDb1g8A0W3V","iconWrapper":"ZoP4yVwml4si5pcS","text":"ilTPYzSKE8kis_Zm"};